export default __webpack_public_path__ + "static/media/tusd.1f62fa07.png";